import { Field } from 'react-final-form';

import { Select } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useFormI18n } from 'src/app/shared/form/hooks';

import type { FieldType, OptionsQuestion } from '../../../../../../shared/types';

import { useOptionsQuestionField } from './hooks/useOptionsQuestionField';

type Props = {
	parent: FieldType;
	question: OptionsQuestion;
	idx: number;
};

export const OptionsQuestionField: React.FC<Props> = ({ parent, question, idx }) => {
	const { typedTranslate } = useI18n();
	const { getErrorMessage } = useFormI18n();
	const {
		data: { fieldName, questionLabel, promptLabel, validator },
		actions: { getQuestionOptionsLabel, changeFieldValue },
	} = useOptionsQuestionField({ parent, question, idx });

	const optionItems = [
		{ id: '', name: '', label: typedTranslate(promptLabel) },
		...question.options.map((option) => ({ id: option, name: option, label: getQuestionOptionsLabel(option) })),
	];

	return (
		<div>
			<Field<string | undefined> name={`${fieldName}.answer`} validate={validator}>
				{({ input, meta }) => (
					<Select
						className="[&_button_span]:text-typography-weak"
						name={input.name}
						selectedKey={input.value}
						onSelectionChange={changeFieldValue}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						data-testid="reportAbuse-option"
						data-qa="reportAbuse-option"
						label={questionLabel}
						items={optionItems}
						isInvalid={meta.touched && !!meta.error}
					/>
				)}
			</Field>
		</div>
	);
};
